<template>
  <div class="media_detail_container">
    <div class="media_info_box" v-if="!!mediaInfo">
      <div class="media_info">
        <div class="media_portrait">
          <div class="portrait">
            <img :src="mediaInfo.lconImagePath" />
          </div>
          <div class="text">
            <div class="nick">
              <span v-text="mediaInfo.name"></span>
              <span class="media_type" v-if="mediaInfo.isReporterFreChannel">媒体号</span>
              <span class="media_type" v-else>湖报号</span>
            </div>
            <div class="num">
              <span>发布 <span v-text="mediaInfo.pubContentsCount"></span></span>
              <span>关注 <span v-text="mediaInfo.subscribeNum"></span></span>
            </div>
            <span class="attention" @click="onAttentionClick($event)" v-text="attentionStr">+ 关注</span>
          </div>
        </div>
        <div class="media_intro">
          <pre v-html="mediaInfo.introduce"></pre>
        </div>
      </div>
      <div class="media_category" v-if="categoryList.length > 1">
        <van-tabs class="media_category_tabs" @click="onTabClick" v-model="selectedIndex" swipe-threshold="2" :line-width="lineWidth">
          <van-tab v-for="item in categoryList" :title="item.name" :key="item.id">
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="cate_content_list" :style="{ height: boxHeight }">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="media_news_list">
        <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
          <news-list :contentList="contentList" :deviceId="deviceId"></news-list>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getRandomStr32, clickPlayCount, addScore } from "@/utils";
import mediaApi from "@/api/apis/media.js";
import commApi from "@/api/apis/common.js";
import NewsList from "./components/MediaNewsList";
export default {
  name: "MediaDetail",
  components: {
    NewsList,
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      /* 设备Id */
      deviceId: null,
      boxHeight: "auto",
      mediaParams: {
        contentType: null,
        id: null,
      },
      mediaInfo: null, //媒体号信息/媒体号信息
      attentionStr: "+ 关注",
      subscribed: false,
      categoryList: [], //媒体号文章分类
      selectedIndex: 0,
      lineWidth: 0, //Tab标签底部条宽度
      refreshing: false,
      loading: true,
      finished: false,
      params: {
        pageNo: 0,
        pageSize: 20,
        contentCategoryId: null,
        frechannelId: null,
      },
      contentList: [], //媒体号文章分类下的文章列表
      contentTotal: 0, //总数
      contentPageCount: 0, //总页数
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
    };
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      let url = location.href.replace("/media_detail?","/index_share?");

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: url
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.mediaInfo.name, _this.mediaInfo.introduce, url, _this.mediaInfo.lconImagePath);
      }).catch((err) => {

      })
    },
    /* 切换分类 */
    onTabClick(index) {
      var _this = this;
      _this.selectedIndex = index;
      _this.params.contentCategoryId = _this.categoryList[index].id;
      _this.lineWidth = _this.categoryList[index].name.length * 14;
      _this.params.pageNo = 0;
      _this.contentList = [];
      _this.contentTotal = 0;
      _this.contentPageCount = 0;
      _this.loadFirstPage = true;
      if (_this.finished) {
        _this.refreshing = false;
      } else {
        _this.refreshing = true;
      }
      _this.loading = false;
      _this.finished = false;
      _this.getContentListByCateId(); // 根据分类Id获取稿件列表
    },
    // 获取媒体号信息
    getMediaInfo() {
      var _this = this;
      mediaApi
        .getSelfMediaById(_this.mediaParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.name;
            _this.mediaInfo = res.data;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            _this.categoryList = res.data.categoryList;
            if (_this.categoryList.length > 0) {
              _this.params.contentCategoryId = _this.categoryList[0].id;
              _this.lineWidth = _this.categoryList[0].name.length * 14;
            } else {
              _this.params.contentCategoryId = null;
            }
            _this.params.frechannelId = res.data.id;
            _this.getContentListByCateId(); // 根据分类Id获取稿件列表
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.mediaInfo.creationTime, // 创建时间
        contentId: this.mediaInfo.id, // 自媒体号Id
        contentTitle: this.mediaInfo.name,
        contentType: 13,
      }
      if (!!this.userInfo) {
        tj_params = Object.assign(tj_params, {
          memberId: this.userInfo.id, //会员id
          nickName: this.userInfo.nickName, //用户名称
        });
      }
      clickPlayCount(tj_params);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "dy", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
        description: "订阅", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
        // contentType: this.mediaParams.contentType, // 非必传，稿件的type
        // contentId: this.mediaParams.id, // 非必传，稿件的id
        // contentName: this.mediaInfo.name, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    // 根据分类Id获取稿件列表
    getContentListByCateId() {
      var _this = this;
      mediaApi
        .findContentPageByFreChannelId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.contentList = res.data.list;
            } else {
              _this.contentList = _this.contentList.concat(res.data.list);
            }
            _this.contentTotal = res.data.total;
            _this.contentPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.pageNo >= _this.contentPageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            /* _this.$toast({
              message: res.message,
              position: "center",
            }); */
            _this.finished = true;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.contentList = [];
      this.contentTotal = 0;
      this.contentPageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getContentListByCateId(); //根据分类Id获取稿件列表
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.pageNo++;
        if (this.params.pageNo < this.contentPageCount) {
          this.loading = true;
          this.getContentListByCateId(); //根据分类Id获取稿件列表
        }
      }
    },
    /* 获取订阅信息 */
    getSubscription() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .isSubscribe(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
          } else {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注 */
    subscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .subscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消关注 */
    unSubscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.mediaParams.id,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .unSubscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
            _this.$toast({
              message: "取消关注成功",
              position: "center",
            });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注/取消关注 */
    onAttentionClick(event) {
      if (!!this.userInfo) {
        /* 已关注则取消关注 */
        if (this.subscribed) {
          this.unSubscribeSelfMedia(); // 取消关注
        } else {
          this.subscribeSelfMedia(); // 关注
        }
      } else {
        this.$router.push("/login");
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "id")) {
      this.mediaParams.contentType = query.contentType;
      this.mediaParams.id = Number(query.id);
      this.getMediaInfo(); //获取自媒体信息
      if (!!this.userInfo) {
        this.getSubscription(); //获取订阅信息
      } else {
        this.deviceId = getRandomStr32();
      }
    }
  },
  updated() {
    var ele1 = document.getElementsByClassName("top_header");
    var ele2 = document.getElementsByClassName("media_info_box");
    let h1 = 0,
      h2 = 0;
    if (ele1.length > 0) {
      h1 = ele1[0].clientHeight;
    }
    if (ele2.length > 0) {
      h2 = ele2[0].clientHeight;
    }
    this.boxHeight = window.innerHeight - h1 - h2 + "px";
  },
};
</script>
<style scoped lang="scss">
.media_detail_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  .media_info_box {
    .media_info {
      padding: 12px 14px;
      background: #b2171b;
      overflow: hidden;
      color: #fdfffc;
      font-size: 13px;
      .media_portrait {
        display: flex;
        .portrait {
          width: 60px;
          height: 60px;
          line-height: 60px;
          margin-right: 15px;
          overflow: hidden;
          background-image: url(~@/assets/images/user_default.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          border: 1px solid #fff;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }
        .text {
          position: relative;
          width: 100%;
          overflow: hidden;
          flex: 1;
          .nick {
            color: #fdfffc;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 36px;
            font-size: 16px;
            .media_type {
              padding: 1px 6px;
              margin-left: 10px;
              border: 1px solid #fff;
              font-size: 12px;
              border-radius: 9px;
            }
          }
          .num {
            font-size: 12px;
            span {
              margin-right: 10px;
            }
          }
          .attention {
            position: absolute;
            right: 0;
            top: 21px;
            padding: 2px 10px;
            background: #fff;
            border-radius: 7px;
            color: #b2171b;
            font-size: 12px;
          }
        }
      }
      .media_intro {
        margin-top: 10px;
        pre {
          white-space: break-spaces;
        }
      }
    }
    .media_category {
      border-bottom: 5px solid #f0eff8;
    }
  }
  .cate_content_list {
    position: relative;
    width: 100%;
    height: 400px;
    .media_news_list {
      width: 100%;
      height: 100%;
      padding: 0 15px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>